<template>
  <form>
    <md-card>
      <md-card-header
        class="md-card-header-icon"
        :class="getClass(headerColor)"
      >
        <div class="card-icon">
          <md-icon>web</md-icon>
        </div>
        <h4 class="title">
          Name
        </h4>
        <help-link :link="helpLink.link" title="name"></help-link>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <md-field>
              <label>Application Name</label>
              <md-input
                v-model="app.tag"
                data-tour="application_tag"
              ></md-input>
            </md-field>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import { HelpLinkTemplate } from "@/fmComponents";
import helpLinks from '../../contextualHelpLinks.js'
export default {
  name: "edit-application-form",
  props: {
    app: null,
    ogApp: null,
    headerColor: {
      type: String,
      default: ""
    }
  },
  components: {
    'help-link': HelpLinkTemplate
  },
  data: () => ({
    helpLink: helpLinks.applicationConfig.tag
  }),
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>